export const APP = '[App]';

export const FETCH_AUTHENTICATED_USER_REQUEST = `${APP} FETCH_AUTHENTICATED_USER_REQUEST`;
export const FETCH_AUTHENTICATED_USER_SUCCESS = `${APP} FETCH_AUTHENTICATED_USER_SUCCESS`;
export const LOGOUT_REQUEST = `${APP} LOGOUT_REQUEST`;
export const LOGOUT_SUCCESS = `${APP} LOGOUT_SUCCESS`;
export const SET_TOKEN = `${APP} SET_TOKEN`;
export const SESSION_EXPIRED = `${APP} SESSION_EXPIRED`;
export const SET_LANGUAGE = `${APP} SET_LANGUAGE`;
export const SET_COMPANIES = 'SET_COMPANIES';
